import React, { useState, useEffect } from "react";
import { Row, Col, Segmented } from "antd";
import productsNotFound from "../../../assets/images/icons/productEmpty.png";
import ProductCard from "../../common/cards/productCard";
import _ from "lodash";

interface CurrentSkincareComponentInterface {
  keepUsing?: any;
  dontUse?: any;
}

const CurrentSkincareComponent: React.FC<CurrentSkincareComponentInterface> = (
  props
) => {
  const { keepUsing, dontUse } = props;
  const [value, setValue] = useState<string | number>("Keep Using");

  const [productArray, setProductArray] = useState(keepUsing);

  useEffect(() => {
    setProductArray(value === "Keep Using" ? keepUsing : dontUse);
  }, [value]);

  return (
    <Row className="skin-profile__currentSkincare">
      <Col span={24}>
        <h2 className="skin-profile__currentSkincare__title">
          From Your Current Skincare
        </h2>
        <div className="skin-profile__currentSkincare__mainContent">
          <div className="skin-profile__currentSkincare__mainContent__segmented">
            <Segmented
              block
              options={["Keep Using", "Do Not Use"]}
              value={value}
              onChange={setValue}
            />
          </div>
          <div className="skin-profile__currentSkincare__mainContent__itemsContainer">
            {productArray?.length === 0 ? (
              <div className="skin-profile__currentSkincare__NotAvailable">
                <div>
                  <img className="noItemsImage" src={productsNotFound} alt="" />
                </div>
                <h4 className="text">All of your products looks good!</h4>
              </div>
            ) : (
              productArray?.map((item?: any, i?: number) => {
                return (
                  <div
                    className="skin-profile__currentSkincare__product-item"
                    key={i}
                  >
                    <ProductCard
                      data={item}
                      value={value}
                      isCurrentSkincare={true}
                      showIcons
                    />
                  </div>
                );
              })
            )}
          </div>
        </div>
      </Col>
    </Row>
  );
};

export default CurrentSkincareComponent;
